import React, { useState } from 'react';
import Button from '@oberoninternal/travelbase-ds/components/action/Button';
import { Box } from '@rebass/grid';
import styled from 'styled-components';
import LinkField from '../LinkField';
import { LinkFieldFragment } from '../../generated/graphql';
import ContentWrapper from '@oberoninternal/travelbase-website/dist/components/ContentWrapper';
import Modal from '@oberoninternal/travelbase-ds/components/layout/Modal';
import AvailabilityTable from '../AvailabilityTable';

interface Props {
    link: LinkFieldFragment;
}

const ButtonBlock = ({ link }: Props) => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <ContentWrapper>
            {link.url === '/#boottijden' ? (
                <>
                    <StyledModal open={modalOpen} onClose={() => setModalOpen(false)} variant="regular">
                        <AvailabilityTable />
                    </StyledModal>
                    <StyledBox pt={3} pb={3}>
                        <Button rounded size="large" onClick={() => setModalOpen(true)}>
                            {link.customText}
                        </Button>
                    </StyledBox>
                </>
            ) : (
                <StyledBox pt={3} pb={3}>
                    <Button rounded size="large">
                        <LinkField link={link} />
                    </Button>
                </StyledBox>
            )}
        </ContentWrapper>
    );
};

export default ButtonBlock;

const StyledBox = styled(Box)`
    display: flex;

    a {
        text-decoration: none;
        cursor: pointer;
        color: ${({ theme }) => theme.colors.neutral['0']};
    }
`;

const StyledModal = styled(Modal)`
    > div {
        width: 100rem !important;
    }
`;
